import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    // Redirect to the static HTML file
    window.location.href = '/privacy.html';
  }, []);

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h2>Loading Privacy Policy...</h2>
    </div>
  );
};

export default PrivacyPolicy;